// 组合的cell
import { HeaderFieldCellMixins, FieldCellMixins } from './mixins.js';
import { YAW__AssignmentDurationThresholdHeaderCell } from './option.js';

const combiner_cell_comp = {
  mixins: [FieldCellMixins],

  template: `
    <div class="justify-between">
      <span class="mr-2">{{ text_value }}</span>
      <div class="chip danger">
        <span>{{ conbined_text_value }}</span>
      </div>
    </div>
  `,

  computed: {
    conbined_text_value: function() {
      return _.pluck(this.entries, 'duration_threshold').join(', ') || '';
    }
  }
};

const combiner_header_cell_mixins = {
  mixins: [HeaderFieldCellMixins],

  components: {
    'duration-threshold-cell': YAW__AssignmentDurationThresholdHeaderCell
  },

  computed: {
    additionalFilter: function() {
      if (this.filter?.value) {
        return (_.find(this.filter.value, (_filter) => _filter.field === this.additionalField)) || {};
      } else {
        return {};
      }
    },

    additionalField: function() {
      return this.field.addition;
    }
  },

  methods: {
    updateFilter: function() {
      this.$emit('filterChanged', false);
    }
  }
};

const YAW__VertexNameHeaderCell = Vue.extend({
  mixins: [combiner_header_cell_mixins],

  template: `
    <div class="filter-field-popover">
      <div class="filter-params-container">
        <div class="input-control left-addon">
          <input type="text"
                 class='controlled-input bordered'
                 placeholder='搜索'
                 v-model.trim='keyword'
                 @keyup.enter='updateFilter' />
          <div class="addon">
            <i class="slp-search"></i>
          </div>
        </div>
        <div class="additional-filter-container">
          <duration-threshold-cell :field='additionalField'
                                  :filter='additionalFilter'
                                  ref='additionalFilterRef'
                                  @filterChanged='updateFilter' />
        </div>
      </div>
    </div>
  `,

  methods: {
    getFilter: function() {
      var add_filter, filters;

      filters = [];
      if (this.keyword) {
        filters.push({ field: this.field, value: this.keyword });
      }
      add_filter = this.$refs.additionalFilterRef.getFilter();
      if (add_filter) {
        filters.push({ field: this.additionalField, value: add_filter });
      }
      if (filters.length) {
        return filters;
      } else {
        return null;
      }
    },

    resetFilter: function() {
      if (this.filter?.value) {
        this.keyword = (_.find(this.filter.value, (_filter) => _filter.field === this.field))?.value || '';
      } else {
        this.keyword = '';
      }
      this.$refs.additionalFilterRef?.resetFilter();
    }
  }
});

const YAW__JourneyStatusHeaderCell = Vue.extend({
  mixins: [combiner_header_cell_mixins],

  data: function() {
    return {
      options: ['processing', 'finished', 'receding', 'cancelled', 'aborted', 'suspended'],
      selectedOptions: []
    };
  },

  template: `
    <div class="filter-field-popover">
      <div class="filter-params-container list">
        <div class="list-item"
            v-for='option in options'
            :key='option'
            @click="toggleOption(option)">
          <div class="content">{{ Skylark.Helpers.translate('journey.status.' + option) }}</div>
          <div class="tip" v-if="isSelected(option)">
            <i class="slp-check"></i>
          </div>
        </div>
      </div>
      <div class="additional-filter-container">
        <duration-threshold-cell :field='additionalField'
                                :filter='additionalFilter'
                                ref='additionalFilterRef'
                                @filterChanged='updateFilter' />
      </div>
    </div>
  `,

  methods: {
    toggleOption: function(option) {
      if (_.contains(this.selectedOptions, option)) {
        this.selectedOptions = _.without(this.selectedOptions, option);
      } else {
        this.selectedOptions.push(option);
      }
      this.$emit('filterChanged', false);
    },

    getFilter: function() {
      var add_filter, filters;

      filters = [];
      if (this.selectedOptions.length) {
        filters.push({ field: this.field, value: this.selectedOptions });
      }
      add_filter = this.$refs.additionalFilterRef.getFilter();
      if (add_filter) {
        filters.push({ field: this.additionalField, value: add_filter });
      }
      if (filters.length) {
        return filters;
      } else {
        return null;
      }
    },

    resetFilter: function() {
      if (this.filter?.value) {
        this.selectedOptions = (_.find(this.filter.value, (filter) => filter.field === this.field))?.value || [];
      } else {
        this.selectedOptions = [];
      }
      this.$refs.additionalFilterRef?.resetFilter();
    },

    isSelected: function(option) {
      return _.contains(this.selectedOptions, option);
    }
  }
});

export {
  combiner_cell_comp as YAW__VertexNameCell,
  combiner_cell_comp as YAW__JourneyStatusCell
};

export { YAW__VertexNameHeaderCell, YAW__JourneyStatusHeaderCell };
